(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    if (!window.textBlockObserver) {
    window.textBlockObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const element = entry.target;
          const customClass = element.dataset.customClass;

          if (customClass) {
            customClass
              .split(/\s+/)
              .filter(Boolean)
              .forEach((className) => {
                element.classList.add(className);
              });
          }

          observer.unobserve(element);
        });
      },
      {
        threshold: 0.1
      }
    );
  }

  document
    .querySelectorAll('.text-block[data-custom-class]')
    .forEach((element) => {
      window.textBlockObserver.observe(element);
    });
  } catch(e) { console.error(e); }
})();

})();
